import './index.scss';
import React, { useRef, useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { selectReduxSlice } from "../../../Store/store";
import { fetchImage } from '../../nonUIFuncs';
import { FontAwesomeIcon as FAIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";

const Menu = ({setShowMenu, setChosenBook, setCurrentPage}) => {
  const reduxState = useSelector(selectReduxSlice);
  const reduxStateRef = useRef(reduxState);
  const [storyBooks, setStorybooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [chosenCategory, setChosenCategory] = useState(null);
  reduxStateRef.current = reduxState;
  useEffect(() => {
    getCategories();
  }, []);


  const getCategories = () => {
    let cats = [];
    reduxStateRef.current.storybookSentence.forEach((cat) => {
      if (!cats.includes(cat.category)) {
        cats.push(cat.category);
      }
    });
    setCategories(cats);
  };
  const getStorybooks = ({cat}) => {
    let allBooks = [];
    let filteredData = reduxStateRef.current.storybookSentence.filter(
      (s) => s.category === cat
    );
    filteredData.forEach((d) => {
      if (!allBooks.includes(d.story)) {
        allBooks.push(d.story);
      }
    });
    setStorybooks(allBooks);
  };
  if (chosenCategory === null) {
    return (
      <div>
        <div className="menu_container">
          {categories.map((cat) => {
            return (
              <div
                key={cat}
                // style={{ // TODO: Place this image when the data is ready
                //   backgroundImage: `url(${fetchImage()})`,
                // }}
                className="menu_storybook_cover hovercursor"
                style={{
                  background: `linear-gradient(-30deg, rgba(99,192,233,1), rgba(20,116,224,1))`,
                }}
                onClick={() => {
                  setChosenCategory(cat);
                  getStorybooks({ cat: cat });
                }}
              >
                <div className="menu_storybook_ribbon">{cat}</div>
              </div>
            );
          })}
        </div>
        <div style={{ height: 250 }} />
      </div>
    );
  } else {
    return (
      <div>
        <div className="menu_container">
          {storyBooks.map((d) => {
            let book = reduxStateRef.current.storybookSentence.filter(
              (s) => s.story === d
            );
            let firstPage = book.find((s) => Number(s.page) === 0);
            return (
              <div
                key={d}
                style={{
                  backgroundImage: `url(${fetchImage(firstPage.App_Art)})`,
                }}
                className="menu_storybook_cover hovercursor"
                onClick={() => {
                  setShowMenu(false);
                  setChosenBook(book);
                  setCurrentPage(firstPage);
                }}
              >
                <div className="menu_storybook_ribbon">{d}</div>
              </div>
            );
          })}
          <div
            onClick={() => setChosenCategory(null)}
            className="menu_back_fab">
            <FAIcon
              style={{ transform: "scaleX(-1)", color: 'white' }}
              icon={faArrowRightFromBracket}
              size="2xl"
            />
          </div>
        </div>
        <div style={{ height: 250 }} />
      </div>
    );
  }

};

export default Menu;